var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: 512,
    viewBox: "0 0 20 20",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_393"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_393)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.903 8c.06.629.097 1.292.097 2 0 .2652-.1054.5196-.2929.7071s-.4419.2929-.7071.2929-.5196-.1054-.7071-.2929-.2929-.4419-.2929-.7071c0-.713-.039-1.378-.105-2h-3.803c-.13898 1.32964-.14032 2.6701-.004 4h1.912c.2652 0 .5196.1054.7071.2929s.2929.4419.2929.7071-.1054.5196-.2929.7071-.4419.2929-.7071.2929h-1.584c.469 2.08 1.202 3.41 1.585 4 0 0 .789.013.926.002.2641-.0171.5243.0703.7245.2433.2002.1731.3243.4179.3455.6817.0193.2644-.0672.5256-.2405.7263-.1733.2006-.4191.3243-.6835.3437-.094.007-1.073.003-1.073.003-5.514 0-10-4.486-10-10 0-5.515 4.486-10 10-10s10 4.485 10 10c0 .379-.036.749-.079 1.116-.0397.256-.1771.4866-.3833.6434-.2062.1567-.4652.2275-.7224.1973-.2573-.0302-.4929-.1589-.6572-.3591-.1644-.2002-.2447-.4564-.2241-.7146.035-.291.066-.583.066-.883 0-.692-.098-1.36-.263-2zm-3.915-5.964c-.386.606-1.1 1.931-1.564 3.964h3.137c-.466-2.033-1.185-3.358-1.573-3.964zm-7.725 9.964h3.819c-.058-.629-.095-1.29-.095-1.996.00064-.66913.03267-1.33787.096-2.004h-3.82c-.166.64-.263 1.308-.263 2 .00249.6751.09086 1.3472.263 2zm.819 2c.9875 1.7037 2.56653 2.9852 4.437 3.601-.52106-1.1517-.90632-2.3602-1.148-3.601zm3.291-8c.301-1.501.735-2.703 1.15-3.603-1.87232.61532-3.45298 1.89771-4.441 3.603zm7.239 0h3.305c-.9921-1.71332-2.5822-2.99968-4.465-3.612.5274 1.15417.9168 2.36656 1.16 3.612z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.2232 18.9454-2.5501-5.6103c-.1912-.4206.2415-.8532.6621-.6621l5.6102 2.5502c.3829.174.3929.7143.0167.9024l-1.7419.8709c-.0968.0484-.1752.1269-.2236.2236l-.871 1.742c-.1881.3762-.7283.3662-.9024-.0167z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.f97fcb45d9c49fba9e5f937f511ace2e.svg";
export { ForwardRef as ReactComponent };